import styled from 'styled-components';

const AssetItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme: { token } }) => token.marginXS}px;
  border: 2px solid ${({ theme: { token } }) => token.colorBorderSecondary};
  padding: ${({ theme: { token } }) => token.padding}px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;

  &:hover {
    background-color: ${({ theme: { token } }) => token.colorBorderSecondary};
    border-color: ${({ theme: { token } }) => token.colorTextPlaceholder};
  }
`;

export default AssetItemContainer;
